export default __webpack_public_path__ + "static/media/centroMoons@1x.8dbcce70.webp";